import React from 'react'
import { BreadcrumbProps } from './Breadcrumb.props'
import {
  BreadcrumbContainer,
  BreadcrumbItem,
  BreadcrumbLink,
} from './Breadcrumb.styled'

const Breadcrumb = ({ breadcrumbPages, pageParam }: BreadcrumbProps) => {
  return (
    <BreadcrumbContainer>
      {breadcrumbPages.map((page, index) => {
        return (
          <BreadcrumbItem key={`breadcrum_${index}`}>
            <BreadcrumbLink to={page.url(pageParam)}>
              {page.title} {index + 1 !== breadcrumbPages.length && '>'}
            </BreadcrumbLink>
          </BreadcrumbItem>
        )
      })}
    </BreadcrumbContainer>
  )
}

export default Breadcrumb
